/* eslint-disable */
export default {
  en: {
    caption: {
      next: "Next",
      back: "Back",
      cancel: "Cancel",
      close: "Close",
      exit: "Exit",
      ok: "OK",
      save: "Save",
      submit: "Submit",
      apply: "Apply",
      edit: "Edit",
      download: "Download",
      add: "Add",
      delete: "Delete",
      tryAgain: "Try again",
      move: "Move",
      start: "Start",
      complete: "Complete",
      sendInvitation: "Send invitation",
      continue: "Continue",
      search: "Search",
      create: "Create",
      loading: "Loading...",
      archive: "Archive",
      unarchive: "Unarchive",
      confirm: "Confirm",
      logout: "Log out",
      select: "Select",
      regenerate: "Regenerate",
      generate: "Generate",
      createDraft: "Create draft",
      remove: "Remove",
    },
    labels: {
      warning: "Warning",
      success: "Success",
      compliant: "Compliant",
      notCompliant: "Not Compliant",
      undetermined: "Undetermined",
    },
    modules: {
      names: {
        activityLog: "Activity log",
        cases: "Cases",
        services: "Services",
        companies: "Companies",
        summary: "Summary",
        companyDetails: "Company Details",
        sponsorLicence: "Sponsor Licence",
        documents: "Documents",
        employees: "Employees",
        tasks: "Tasks",
        dataHistory: "Data History",
        candidates: "Candidates",
        company: "Company",
        visaCases: "Visa Cases",
      },
    },
    services: {
      candidateAssessment: "Candidate Assessment",
      candidateEligibilityCheck: "Candidate eligibility check",
      sponsorLicence: "Sponsor Licence",
    },
    roles: {
      employer: "Employer",
      employee: "Employee",
      employees: "Employees",
      expert: "Expert",
      candidate: "Candidate",
    },
    belongsToRole: {
      expert: "Expert",
      employer: "Employer",
      employee: "Employee",
      company_and_candidate: "Company & candidate",
      employer_and_candidate: "Employer & candidate",
      company: "Company",
      candidate: "Candidate",
      home_office: "Home office",
      nation_better: "Nation.better",
    },
    table: {
      allLabel: "All",
      placeholderLabel: "There are no cases",
    },
    error: {
      default: "Oops! An error occurred.",
      dataNotLoaded: "While loading data occurred an error or the data was not completely loaded.",
      emailTemplateNotGenerated: "HO report email template is not generated yet",
    },
    titles: {
      mr: "Mr",
      mrs: "Mrs",
      miss: "Miss",
      ms: "Ms",
    },
    notification: {
      copied: "Copied to clipboard",
    },
  },
};
